<template>
  <div v-if="user_logged_in === false" style="background-color: white">
    <div class="card-content">

    <div class="row">
      <div v-if="loading === true" class="loading-wrapper">
        <loading></loading>
      </div>

      <form v-else-if="needConfirm === true" class="col s12" id="form-login" onsubmit="return false">
        <div id="corpo" class="mensagem-about-geral">
          <div class="row">
            <div class="modal-header col s12 center-align">
              <a @click="goHome">
                <img style="width: 100%;height: 40px;" src="@/assets/img/logo_recad_azul.svg" alt="Logo IPEJUN">
              </a>
            </div>
          </div>
          <div class="row">
            <div class="modal-header col s12 center-align">
              <h5>Confirme sua Identidade</h5> <br>
            </div>
            <div v-if="needCode === true" class="row">
              <div class="input-field col s10 offset-s1 code" id="wrap_code">
                <input v-mask="['######']" id="code" name="code" type="text" v-model="codeInput" ref="code">
                <label v-bind:class="{ active: codeInput }" for="code">Código</label>
              </div>
              <div class="input-field col s10 offset-s1 center">
                <button @click="verifyCode" class="waves-effect waves-light btn" id="btnContinuar">Confirmar</button>
              </div>
            </div>
            <div v-else class="login-sms-options">
              <div v-for="(sms, i) in smsPhones" v-bind:key="i" class="login-sms-option" @click="sendCode('SMS', sms.cellphone_id)">
                <div class="login-sms-option-title">Receber SMS em:</div>
                <div class="login-sms-option-label">{{ sms.cellphone }}</div>
              </div>
              <div v-for="(sms, i) in smsEmails" v-bind:key="i" class="login-sms-option" @click="sendCode('EMAIL', sms.email_id)">
                <div class="login-sms-option-title">Receber email em:</div>
                <div class="login-sms-option-label">{{ sms.email }}</div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <form v-else class="col s12" id="form-login" onsubmit="return false">
        <div id="corpo" class="mensagem-about-geral">
        <div class="row">
          <div class="modal-header col s12 center-align">
            <a @click="goHome">
              <img style="width: 100%;height: 40px;" src="@/assets/img/logo_recad_azul.svg" alt="Logo IPEJUN">
            </a>
          </div>
        </div>

        <template v-if="login === true && user_logged_in === false">
          <div class="row">
            <div class="modal-header col s12 center-align">
              <div v-if="entidade_banner" class="banner">
                <img :src="entidade_banner" alt="entidade_banner" width="30%">
              </div>
              <h5>{{ meta.login.new_session }}</h5> <br>
            </div>
            <div v-if="censo_domain_esp">
              <div class="input-field col s10 offset-s1 cpf" id="wrap_cpf" v-if="showMunicipioSelect === true">
                <select v-model="selectedMunicipio" @change="handlerChange">
                  <option :value="null" disabled selected>Selecione</option>
                  <option :value="domain_name" >{{ domain_name }}</option>
                </select>
                <label>Município Ou Estado</label>
              </div>
            </div>
            <div v-else>
              <div class="input-field col s10 offset-s1 cpf" id="wrap_cpf" v-if="showMunicipioSelect === true">
                <select v-model="selectedMunicipio" @change="handlerChange">
                  <option :value="null" disabled selected>Selecione</option>
                  <option v-for="(municipio, i) in meta.censo_domain" v-bind:key="i" v-bind:value="i">{{ municipio.nome }}</option>
                </select>
                <label>Município Ou Estado</label>
              </div>
            </div>
          </div>
          <template v-if="selectedMunicipio !== null ">
            <div class="row">
              <div class="input-field col s10 offset-s1 cpf" id="wrap_cpf">
                <input v-mask="['###.###.###-##']" id="campo_cpf" name="campo_cpf" type="text" v-model="cpfInput" ref="cpf">
                <label v-bind:class="{ active: cpfInput }" for="campo_cpf">{{ meta.login.cpf }}</label>
              </div>
              <div class="input-field col s10 offset-s1" id="wrap_dt_nasc">
                <input v-mask="['##/##/####']" id="campo_dt_nasc" name="campo_dt_nasc" type="text" v-model="dt_nasc" ref="nascimento">
                <label v-bind:class="{ active: dt_nasc }" for="campo_dt_nasc">{{ meta.login.dt_nasc }}</label>
                <div class="card-panel red lighten-4 red-text text-darken-4" v-if="mensagemErro">{{ mensagemErro }}</div>
              </div>
              <div class="input-field col s10 offset-s1">
                <label style="margin-top:-10px;">
                  <input v-model="allow" type="checkbox" class="filled-in" />
                  <span>&nbsp;</span>
                </label>
                <span style="margin-left:30px">Li e aceito os <a @click="goToPage('/Termos/')"> termos de uso </a>(Lei Geral de Proteção de Dados - 13.709/2018).</span>
              </div>
              <div class="input-field col s12 offset-s1 center">
                <vue-recaptcha v-bind:sitekey="RE_CAPTCHA_S_KEY" v-bind:loadRecaptchaScript="true" @verify="captchaCallback" @error="captchaErrorCallback" @expired="captchaExpireCallback" @render="captchaRenderCallback" />
              </div>
              <div class="input-field col s10 offset-s1 center">
                <button @click="submitLoginSegurado" v-bind:disabled="loginEnabled === false" class="waves-effect waves-light btn" id="btnContinuar">{{ meta.buttons.send }}</button>
              </div>
            </div>
          </template>
        </template>

        <template v-else>
          <div class="row">
            <div class="col s12 mensagem-login">
              <h5 class="center">Atenção!</h5>
              <p v-if="status_code in meta.censo_domain[selectedMunicipio].login_error_messages" class="flow-text warning-card" v-html="meta.censo_domain[selectedMunicipio].login_error_messages[status_code]"></p>
              <p v-else class="flow-text warning-card">
                Você não possui um cadastro de servidor em nossa base de dados, por este motivo infelizmente o auto-recadastramento não está disponível para você.
                Dirija até um de nossos locais de atendimento, para mais informações visite o site do Censo Previdenciário®.
              </p>
              <a @click="voltarLogin" class="waves-effect waves-light btn">Voltar</a>
            </div>
          </div>
        </template>
        </div>
      </form>
    </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import Vuelidate from 'vuelidate'
import hmacSHA256 from 'crypto-js/hmac-sha256'
import {required, minLength, maxLength} from 'vuelidate/lib/validators'
import {validaCPF, verificaTokenUsuario} from '@/assets/js/script.js'
import {formataCPF, verificaData, formataData} from '@/assets/js/form-utils.js'
import {showModalLogin, hideModalLogin} from '@/assets/js/scripts-login'

import Loading from '@/components/Loading.vue'
import { CONFIG } from '@/config/config.js'
import VueRecaptcha from 'vue-recaptcha'
import MunicipioSeletor from '../mixins/municipioSeletor'

Vue.use(Vuelidate)

export default {
  name: 'LoginApp',
  mixins: [MunicipioSeletor],
  data () {
    return {
      meta: this.$store.state.meta.data,
      selectedMunicipio: null,
      showMunicipioSelect: true,
      loading: false,
      onx_account_choser: {},
      newSess: false,
      cpfInput: '',
      dt_nasc: '',
      allow: false,
      mensagemErro: null,
      login: true,
      user_logged_in: false,
      status_code: null,
      uuid: null,
      senha: null,
      show_email_list: false,
      show_code_new_pass: false,
      cpf_recover_pass: null,
      emails: {},
      email_id: null,
      code: null,
      error: null,
      captcha_token: null,
      RE_CAPTCHA_S_KEY: CONFIG.RE_CAPTCHA_S_KEY,
      // SMS
      challengeQuestionsLabels: null,
      reCaptchaByPass: '',
      loginSecret: '',
      authAccessToken: '',
      appAccessToken: '',
      smsEmails: [],
      smsPhones: [],
      smsPfId: '',
      codeInput: '',
      smsResourceId: '',
      sms_access_token: '',
      needConfirm: false,
      needCode: false,
      entidade_banner: '',
      censo_domain_esp: false,
      domain_name: '',
      challengeQuestionsLabels: this.$store.state.meta.data.challenge_questions_labels
    }
  },
  computed: {
    loginEnabled: function() {
      return(this.cpfInput && validaCPF(this.cpfInput) === true && this.dt_nasc && this.allow && verificaData(this.dt_nasc) === true && this.captcha_token !== null ? true : false)
    }
  },
  watch: {
    cpfInput: function (cpfUser) {
      cpfUser = (cpfUser ? cpfUser.replace(/\D/g, '') : '')
      if (cpfUser.length == 11) {
        if (validaCPF(cpfUser) === true) {
          this.$refs.nascimento.focus()
        } else {
          this.mensagemErro = this.meta.login.error_cpf_login
        }
      } else if (cpfUser.length <= 10) {
        this.mensagemErro = null
      }
    },
    senha: function (senha) {
      this.mensagemErro = null
    }
  },
  methods: {
    setup_domain(){
      const meta_data = this.$store.state.meta.data;
      const host = meta_data.host || null;
      if (host) {
        this.censo_domain_esp = true;

        if (meta_data.censo_domain && meta_data.censo_domain[host]) {
          this.domain_name = meta_data.censo_domain[host].nome || "";
        }
        this.entidade_banner = meta_data.censo_domain_banner;
      }
    },
    handlerChange(){
      if(this.selectedMunicipio !== null) {
        localStorage.setItem('selectedMunicipio', this.selectedMunicipio)
        setTimeout(() => this.$refs.cpf.focus(), 100)
      }
    },
    formataLogin(login){
      if(isNaN(login) === false && login.length === 11){
        return formataCPF(login)
      } else {
        return login
      }
    },
    goToPage(page) {
      this.$router.push(page)
    },
    emptyAccountsChoser () {
      if (Object.keys(this.onx_account_choser).length > 0){
        return false
      } else {
        return true
      }
    },
    selectAccount (uuid) {
      this.uuid = uuid
    },
    resetLoginView () {
      this.loading = false
      this.cpfInput = ''
      this.dt_nasc = ''
    },
    async submitLoginSegurado () {
      if (this.cpfInput && validaCPF(this.cpfInput) === true && this.dt_nasc && verificaData(this.dt_nasc) === true) {
        this.loading = true

        axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v2/pessoa-fisica/login/`, {
          "cpf": this.cpfInput.replace(/[^0-9]/g, ''),
          "nascimento": formataData(this.dt_nasc),
          "oid":  this.meta.censo_domain[this.selectedMunicipio].login_segurado.oid,
          "oeid": this.meta.censo_domain[this.selectedMunicipio].login_segurado.oeid,
          "response_token": this.captcha_token
        }).then(async (response) => {
          const accessToken = response.data.data.SocialAPI.access_token;
          const needConfirm = await this.signIn();

          this.sms_access_token = accessToken;

          if (needConfirm) {
            this.loading = false
          } else {
            this.continueSubmitLoginSegurado(accessToken);
          }
        }).catch(error => {
          if ([401, 403, 404].includes(error.response.status) === true) { // Statuses de erros simples
          console.log(error.response.status)
            this.mensagemErro = this.getLoginErrorMensage(error.response.status)
            console.log(this.mensagemErro)
          } else {
            this.login = false
            this.status_code = error.response.status
          }
        }).finally(() => {
          this.loading = false
          setTimeout(() => M.FormSelect.init(document.querySelectorAll('select')), 100)
        })
      }

      return false
    },
    continueSubmitLoginSegurado(token) {
      localStorage.token = token
        this.$store.dispatch("loadUserDataFromToken", localStorage.token)
        this.resetLoginView()
        this.$emit('userLogedIn')

        let user_data = JSON.parse(window.atob(localStorage.token.split('.')[1]))['data']['user']
        if(user_data['status'] === 'limited'){
          this.$router.push('/Status/')
        } else {
          this.$router.push('/Ajuda/')
        }
    },
    async signIn () {
      const response = await axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v2/person/login/contact/`, {
        'cpf': this.cpfInput.replace(/[^0-9]/g, ''),
        'oid':  this.meta.censo_domain[this.selectedMunicipio].login_segurado.oid,
        'oeid': this.meta.censo_domain[this.selectedMunicipio].login_segurado.oeid,
        'response_token': "03ik0kf3)",
        're-captcha-by-pass': null,
	    })

      if ((response.data.success === true) && response.data.data.SocialAPI) {
        if (response.data.data.SocialAPI.emails && response.data.data.SocialAPI.cellphones) {
          this.smsEmails = response.data.data.SocialAPI.emails;
          this.smsPhones = response.data.data.SocialAPI.cellphones;
          this.smsPfId = response.data.data.SocialAPI.pf_id;
          if (response.data.data.SocialAPI.emails.length || response.data.data.SocialAPI.cellphones.length) {
            this.needConfirm = true;
            return true;
          }
        }
      }

      return false;
    },
    async sendCode (type, resourceId) {
      this.needCode = true;
      this.smsResourceId = resourceId;

      if (type === 'EMAIL') {
        this.requestCodeByEmail(resourceId);
      } else if (type === 'SMS') {
        this.requestCodeBySMS(resourceId);
      }
    },
    async requestCodeByEmail(resourceId) {
      await axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/person/login/email/send-code/`, {
        'pf_id': this.smsPfId,
        'email_id': resourceId
	    });
    },
    async requestCodeBySMS(resourceId) {
      await axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/person/login/cellphone/send-code/`, {
        'pf_id': this.smsPfId,
        'cellphone_id': resourceId
	    });
    },
    async verifyCode () {
      this.loading = true;

      try {
        const response = await axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/person/login/`, {
          'pf_id': this.smsPfId,
          'code': this.codeInput,
          'resource_id': this.smsResourceId, // email_id ou cellphone_id
          'oid':  this.meta.censo_domain[this.selectedMunicipio].login_segurado.oid,
          'oeid': this.meta.censo_domain[this.selectedMunicipio].login_segurado.oeid,
        });

        if (response.data && (response.data.success === true) && response.data.data.SocialAPI && response.data.data.SocialAPI.access_token) {
          this.continueSubmitLoginSegurado(this.sms_access_token);
        } else {
          this.loading = false;
          this.needCode = false;
          M.toast({html: 'Código inválido'})
        }
      } catch(exception) {
        this.loading = false;
        this.needCode = false;
        M.toast({html: 'Código inválido'})
      }
    },
    getLoginErrorMensage(status_code){
      try {
        return this.meta.censo_domain[this.selectedMunicipio].login_error_messages[status_code]
      } catch (error) {
        switch (status_code) {
          case 401:
          case 403:
            return "Os dados informados não conferem"
            break;
          case 404:
            return "Cadastro não localizado...verifique seus dados e tente novamente."
            break
          default:
            return "Não foi possível executar esta operação no momento...verifique a sua conexão com a internet e tente novamente em instantes."
            break
        }
      }
    },
    removeAccountFromChoser (uuid) {
      if (uuid in this.onx_account_choser) {
        delete this.onx_account_choser[uuid]
        this.updateAccountsChoser()
        this.resetLoginView()
      }
    },
    updateAccountsChoser () {
      var newAccountsChoser = {'data': [this.onx_account_choser]}
      localStorage.onx_account_choser = JSON.stringify(newAccountsChoser)
    },
    captchaCallback(token){
      this.captcha_token = token
    },
    captchaExpireCallback(error){
      this.captcha_token = null
    },
    captchaErrorCallback(error){
      M.toast({html: 'Você deve verificar o captcha corretamente'})
      this.captcha_token = null
    },
    captchaRenderCallback(data) {
      setTimeout(() => {
        try{
          document.querySelectorAll('body div:last-child')[14].setAttribute('class', 're-captcha-container')
        } catch (e) {

        }
      }, 1000)
    },
    voltarLogin(){
      this.login = true;
      this.status_code = null
      setTimeout(() => M.FormSelect.init(document.querySelectorAll('select')), 100)
    },
    goHome(){
      this.$router.push('/')
    },
  },
  async mounted () {
    this.setup_domain()
    this.municipioSeletor()
    setTimeout(() => M.FormSelect.init(document.querySelectorAll('select')), 100)
    this.resetLoginView()
    let verificaToken = await verificaTokenUsuario()
    if(verificaToken !== true){
      this.user_logged_in = false
      // showModalLogin()
    } else {
      this.user_logged_in = true
      this.$store.dispatch("loadUserDataFromToken", localStorage.token)
      this.$emit('userLogedIn', {'AS': new Date()})
    }
  },
  created () {
    this.needConfirm = false;
    this.needCode = false;
  },
  updated () {
    this.meta = this.$store.state.meta.data
  },
  validations: {
    campo_cpf: {
      required,
      minLength: minLength(11),
      maxLength: maxLength(11)
    }
  },
  components: {
    'loading': Loading,
    'vue-recaptcha': VueRecaptcha,
  }
}
</script>
<style>
  .mensagem-login {
    padding: 25px;
  }
  @media only screen and (max-width: 600px) {
    body div.re-captcha-container {
      left: inherit !important;
      top: 10px !important;
    }
  }
  .warning-card {
    margin: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue